"use strict";

/**
 * @generated SignedSource<<2dd1a763bc09c4acba0a32231869d476>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "supplierSlug"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "slug",
      "variableName": "supplierSlug"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    v3 = {
      "kind": "InlineFragment",
      "selections": [{
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "audience",
          "value": "SUPPLIER"
        }],
        "concreteType": "ConfigurationWarning",
        "kind": "LinkedField",
        "name": "configurationWarnings",
        "plural": true,
        "selections": [v2 /*: any*/],
        "storageKey": "configurationWarnings(audience:\"SUPPLIER\")"
      }],
      "type": "Supplier",
      "abstractKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "getOutstandingOnboardingActionsNum_Query",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [v3 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "getOutstandingOnboardingActionsNum_Query",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "supplier",
        "plural": false,
        "selections": [v2 /*: any*/, v3 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }],
          "type": "Node",
          "abstractKey": "__isNode"
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "31f7b0f6e764b041377577952e3e3e52",
      "id": null,
      "metadata": {},
      "name": "getOutstandingOnboardingActionsNum_Query",
      "operationKind": "query",
      "text": "query getOutstandingOnboardingActionsNum_Query(\n  $supplierSlug: String!\n) {\n  supplier(slug: $supplierSlug) {\n    __typename\n    ... on Supplier {\n      configurationWarnings(audience: SUPPLIER) {\n        __typename\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
    }
  };
}();
node.hash = "521d7530d7ae3d8876d3440d993ea1f8";
export default node;